import { Suspense } from "react"
import { Outlet } from "react-router-dom"
import { AppSidebar } from "@/components/app-sidebar/app-sidebar.tsx"
import { LoadingAnimation } from "@/components/loading-animation/loading-animation.tsx"
import { SidebarProvider } from "@/components/shadcn/sidebar"

const DesktopSidebarLayout = () => {
  return (
    <SidebarProvider>
      <div className="flex h-screen w-screen">
        <AppSidebar />
        <main className="w-full flex-1 justify-center overflow-y-auto">
          <Suspense fallback={<LoadingAnimation />}>
            <Outlet />
          </Suspense>
        </main>
      </div>
    </SidebarProvider>
  )
}

export default DesktopSidebarLayout
